import { useCallback } from "react";
import { useWallet } from "use-wallet";
import { useLockedSwapContract } from "./useContract";
import {SendFun,CallFun } from '../utils/contract';

function useSimpleSwapLocked(address) {
  const { account } = useWallet();
  const contract = useLockedSwapContract(address);
  

//function swapToken(address  swaptokenAddr,uint256 value) public payable
const swapToken = useCallback(
  async (swaptokenAddr,value, setLoading, isErc20) => {
    return await SendFun(
      contract,
      account,
      "swapToken",
      [ swaptokenAddr,value ],
      setLoading,
      isErc20 ? null : value
    );
  },
  [account, contract]
);

//function swapCommToken(address  fromTokenAddr,uint256 value, address  toTokenAddr) public payable

const swapCommToken = useCallback(
  async (fromTokenAddr,value,toTokenAddr, setLoading, isErc20) => {
    return await SendFun(
      contract,
      account,
      "swapCommToken",
      [ fromTokenAddr,value,toTokenAddr ],
      setLoading
    );
  },
  [account, contract]
);
  
  
//  function withdrawTokens(address token,address to,uint256 amount) public onlyOwner {

  const withdrawTokens = useCallback(
    async ( token,to,amount , setLoading, isErc20) => {
      return await SendFun(
        contract,
        account,
        "withdrawTokens",
        [ token,to,amount ],
        setLoading
      );
    },
    [account, contract]
  );




  // function setBaseTokenPrice(uint256 value) public onlyOwner {
    const setBaseTokenPrice = useCallback(
      async (value, setLoading) => {
        return await SendFun(
          contract,
          account,
          "setBaseTokenPrice",
          [ value],
          setLoading
        );
      },
      [account, contract]
    );
	
    //function setTokenMulPrices(address[] memory tokenaddr,uint256[] memory value,string[] memory tokename) public onlyOwner
     
    const setTokenMulPrices = useCallback(
      async ( tokenaddr, value,tokename , setLoading) => {
        return await SendFun(
          contract,
          account,
          "setTokenMulPrices",
          [ tokenaddr, value,tokename ],
          setLoading
        );
      },
      [account, contract]
    );

    
    //function setTokenPrices(address tokenaddr,uint256 value,string memory tokename) public onlyOwner
    const setTokenPrices = useCallback(
      async (tokenaddr, value,tokename , setLoading) => {
        return await SendFun(
          contract,
          account,
          "setTokenPrices",
          [ tokenaddr, value,tokename ],
          setLoading
        );
      },
      [account, contract]
    );
       
    //function setTokenName(address tokenaddr,string memory tokename) public onlyOwner

    const setTokenName = useCallback(
      async (tokenaddr, tokename , setLoading) => {
        return await SendFun(
          contract,
          account,
          "setTokenName",
          [ tokenaddr, tokename ],
          setLoading
        );
      },
      [account, contract]
    );
       
    //function setDecimals(uint8 _decimals) public onlyOwner

    
    const setDecimals = useCallback(
      async ( _decimals , setLoading) => {
        return await SendFun(
          contract,
          account,
          "setDecimals",
          [ _decimals ],
          setLoading
        );
      },
      [account, contract]
    );
        
    //function setTokenAddr(address _tokenAddr) public onlyOwner

        
    const setTokenAddr = useCallback(
      async ( _tokenAddr , setLoading) => {
        return await SendFun(
          contract,
          account,
          "setTokenAddr",
          { _tokenAddr },
          setLoading
        );
      },
      [account, contract]
    );
        
    //function setUsdtAddr(address _usdtAddr) public onlyOwner

    const setUsdtAddr = useCallback(
      async ( _usdtAddr , setLoading) => {
        return await SendFun(
          contract,
          account,
          "setUsdtAddr",
          { _usdtAddr },
          setLoading
        );
      },
      [account, contract]
    );
       
    //function getTokens() public view returns ( address[] memory,uint256[] memory,string[] memory) 
      
    // address public USDT_ADDRESS;
const USDT_ADDRESS = useCallback(
  async ( setLoading) => {
    return await CallFun(
      contract,
      account,
      "USDT_ADDRESS",
      [],
      setLoading
    );
  },
  [account, contract]
);
const LOCKED_ADDRESS = useCallback(
  async ( setLoading) => {
    return await CallFun(
      contract,
      account,
      "LOCKED_ADDRESS",
      [],
      setLoading
    );
  },
  [account, contract]
);
const  getLockedAddr=LOCKED_ADDRESS;
const TOKEN_ADDRESS = useCallback(
  async ( setLoading) => {
    return await CallFun(
      contract,
      account,
      "TOKEN_ADDRESS",
      [],
      setLoading
    );
  },
  [account, contract]
);
const  getTokeAddr=TOKEN_ADDRESS;
const getpledgedays = useCallback(
  async ( setLoading) => {
    return await CallFun(
      contract,
      account,
      "pledgedays",
      [],
      setLoading
    );
  },
  [account, contract]
);
const getgapdays = useCallback(
  async ( setLoading) => {
    return await CallFun(
      contract,
      account,
      "gapdays",
      [],
      setLoading
    );
  },
  [account, contract]
);
const getstartprenum = useCallback(
  async ( setLoading) => {
    return await CallFun(
      contract,
      account,
      "startprenum",
      [],
      setLoading
    );
  },
  [account, contract]
);
const getminamount = useCallback(
  async ( setLoading) => {
    return await CallFun(
      contract,
      account,
      "minamount",
      [],
      setLoading
    );
  },
  [account, contract]
);
// address public TOKEN_ADDRESS;
const getTokensInfo = useCallback(
  async (setLoading) => {
    return await CallFun(
      contract,
      account,
      "getTokensInfo",//  TOKEN_ADDRESS
      [],
      setLoading
    );
  },
  [account, contract]
);

    const getFromTokens = useCallback(
      async ( setLoading) => {
        return await CallFun(
          contract,
          account,
          "getFromTokens",
          [],
          setLoading
        );
      },
      [account, contract]
    );
    const getToTokens = useCallback(
      async ( setLoading) => {
        return await CallFun(
          contract,
          account,
          "getToTokens",
          [],
          setLoading
        );
      },
      [account, contract]
    );
    const getAllTokens = useCallback(
      async ( setLoading) => {
        return await CallFun(
          contract,
          account,
          "getAllTokens",
          [],
          setLoading
        );
      },
      [account, contract]
    );

    const setMinAmount = useCallback(
      async (minamount, setLoading) => {
        return await SendFun(
          contract,
          account,
          "setMinAmount",
          [minamount],
          setLoading
        );
      },
      [account, contract]
    );
    // 配置锁仓地址
    const setLockedAddr = useCallback(
      async (lockedaddr, setLoading) => {
        return await SendFun(
          contract,
          account,
          "setLockedAddr",
          [lockedaddr],
          setLoading
        );
      },
      [account, contract]
    );
    // 配置锁仓参数
    const setLockedParam = useCallback(
      async (pledgedays,gapdays,startprenum, setLoading) => {
        return await SendFun(
          contract,
          account,
          "setLockedParam",
          [pledgedays,gapdays,startprenum],
          setLoading
        );
      },
      [account, contract]
    );

    const getLockedParam = useCallback(
      async ( setLoading) => {
        return await CallFun(
          contract,
          account,
          "getLockedParam",
          [  ],
          setLoading
        );
      },
      [account, contract]
    );

    
    const getTokenPrice = useCallback(
      async ( tokenaddr,setLoading) => {
        return await CallFun(
          contract,
          account,
          "getTokenPrice",
          [ tokenaddr ],
          setLoading
        );
      },
      [account, contract]
    );

    

   // function getSwapValue(address fromTokenAddr,uint256 value, address  toTokenAddr)  public view returns (uint256) 
  // 获得交换后的数量
   const getSwapValue = useCallback(
    async (fromTokenAddr,value,toTokenAddr , setLoading) => {
      return await CallFun(
        contract,
        account,
        "getSwapValue",
        [fromTokenAddr,value,toTokenAddr ],
        setLoading
      );
    },
    [account, contract]
  );


  return {
    swapContract:contract,
    USDT_ADDRESS,
    TOKEN_ADDRESS,
    LOCKED_ADDRESS,
    getLockedAddr,
    getTokeAddr,
    getpledgedays,
    getgapdays,
    getstartprenum,
    getminamount,
    getTokenPrice,
    getAllTokens,
    swapToken,
    swapCommToken,
    withdrawTokens,
    setTokenName,
    setBaseTokenPrice,
    setTokenPrices,
    setTokenMulPrices,
    setDecimals,
    setTokenAddr,
    setUsdtAddr,
    setMinAmount,
    getFromTokens,
    getToTokens,
    setLockedAddr,
    setLockedParam,
    getLockedParam,
    getSwapValue,
    getTokensInfo
   
  };
}


export default useSimpleSwapLocked;
